<h1 class="page-header"><i class="fa fa-pencil-square" aria-hidden="true"></i> API TOKEN</h1>
<div class="container-fluid">

	<div class="page-button">
		<a href="#apiToken" data-toggle="modal" class="btn btn-primary btn-sm" role="button"><i class="fa fa-plus"
				aria-hidden="true"></i> CREATE NEW TOKEN</a>
		<span id="userOptionsBar"></span>

		<div class="btn-group edgefinityHeader">
			<button type="button" class="btn btn-primary btn-sm dropdown-toggle" data-toggle="dropdown"
				aria-haspopup="true" aria-expanded="false">
				<i class="fa fa-wrench" aria-hidden="true"></i> ACTIONS <span class="caret"></span>
			</button>
			<ul class="dropdown-menu">

				<li (click)="onDelete()" [class.disabled]="isEmptySelection()"><a><em class="fa fa-remove"></em>
						DELETE</a></li>
			</ul>
		</div>
		
		<!-- RESULTS PER PAGE -->
		<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
			<button type="button" class="btn btn-primary btn-sm dropdown-toggle" data-toggle="dropdown">
				<em class="fa fa-bars"></em> RESULTS PER PAGE <span class="caret"></span>
			</button>
			<ul class="dropdown-menu">
				<li *ngFor="let value of resultsPerPageValues" (click)="manageResultPerPageClickedForToken(value)"
					[class.active]="value === selectedPageSizeValueForToken">
					<a>{{ value }}</a>
				</li>
			</ul>
		</div>
	</div>


	<div class="modal fade" id="apiToken" #apiTokenModal role="dialog">
		<div class="modal-dialog">


			<div class="modal-content">
				<div class="modal-header">
					<button type="button" class="close" data-dismiss="modal"><i class="fa fa-times"
							aria-hidden="true"></i></button>
					<h4 class="modal-title"><i class="fa fa-pencil-square" aria-hidden="true"></i> API TOKEN</h4>
				</div>
				<div class="modal-body">

					<!-- USER SELECTION -->
					<div class="row">
						<div class="col-sm-3"><label class="labelRequired">User: </label></div>
						<div class="col-sm-9">
							<input type="text" class="form-control" [(ngModel)]="selectedUserLogin" [typeahead]="users"
								[typeaheadOptionField]="'login'" (typeaheadOnSelect)="onUserSelected($event)"
								placeholder="Select a user..." />
						</div>
					</div>

					<!-- DESCRIPTION FIELD -->
					<div class="row" style="margin-top:10px;">
						<div class="col-sm-3"><label class="labelRequired">Description: </label></div>
						<div class="col-sm-9">
							<input class="form-control" type="text" [(ngModel)]="description" 
								maxlength="150" placeholder="Enter token description" />
						</div>
					</div>

				</div>

				<div class="modal-footer">
					<button type="button" class="btn btn-default" data-dismiss="modal" (click)="onCancelClicked()"><i
							class="fa fa-ban" aria-hidden="true"></i> CANCEL</button>
					<button type="button" class="btn btn-primary" data-dismiss="modal" (click)="onCreateClicked()"><i
							class="fa fa-plus" aria-hidden="true"></i> CREATE</button>
				</div>
			</div>

		</div>
	</div>

	<div class="table-responsive" id="userTableHolder">
		<table class="table tablesorter tablesorter-default table-hover" data-toggle="table" data-id-field="userid"
			role="grid">
			<thead>
				<tr role="row" class="tablesorter-headerRow">
					<th data-column="0" class="tablesorter-header tablesorter-headerUnSorted table-checkbox"
						tabindex="0" scope="col" role="columnheader" aria-disabled="false" aria-controls="table1"
						aria-sort="none" aria-label=": No sort applied, activate to apply an ascending sort"
						style="user-select: none; width: 20px">
						<div class="tablesorter-header-inner">
							<div class="checkbox checkbox-inline"><input type='checkbox' class="styled"
									[checked]="isAllSelected()" (change)="selectAll($event)"><label
									for="checkbox"></label>
							</div>
						</div>
					</th>
					<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
						data-field="name" data-sortable="true" data-column="1" tabindex="0" scope="col"
						role="columnheader" aria-disabled="false" aria-controls="table1" aria-sort="none"
						aria-label="Name: No sort applied, activate to apply an ascending sort">
						<div class="tablesorter-header-inner">TOKEN</div>
					</th>
					<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
						data-field="name" data-sortable="true" data-column="2" tabindex="0" scope="col"
						role="columnheader" aria-disabled="false" aria-controls="table1" aria-sort="none"
						aria-label="Name: No sort applied, activate to apply an ascending sort">
						<div class="tablesorter-header-inner">USER</div>
					</th>
					<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
						data-field="name" data-sortable="true" data-column="2" tabindex="0" scope="col"
						role="columnheader" aria-disabled="false" aria-controls="table1" aria-sort="none"
						aria-label="Name: No sort applied, activate to apply an ascending sort">
						<div class="tablesorter-header-inner">Created By</div>
					</th>
					<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
						data-field="name" data-sortable="true" data-column="2" tabindex="0" scope="col"
						role="columnheader" aria-disabled="false" aria-controls="table1" aria-sort="none"
						aria-label="Name: No sort applied, activate to apply an ascending sort">
						<div class="tablesorter-header-inner">DESCRIPTION</div>
					</th>
					<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
						data-field="groups" data-sortable="true" data-column="3" tabindex="0" scope="col"
						role="columnheader" aria-disabled="false" aria-controls="table1" aria-sort="none"
						aria-label="Groups: No sort applied, activate to apply an ascending sort">
						<div class="tablesorter-header-inner">CREATION DATE</div>
					</th>
				</tr>
			</thead>
			<tbody aria-live="polite" aria-relevant="all">
				<ng-container
					*ngFor="let tokenHeader of tokenHeaders | paginate: {id: 'apitoken_pagination', itemsPerPage: selectedPageSizeValueForToken, currentPage: currentPageForToken, totalItems: totalNumberOfToken }">
					<tr>
						<td>
							<div class="checkbox checkbox-inline"><input type='checkbox' class="styled"
									[(ngModel)]="tokenHeader.selected"><label for="checkbox"></label></div>
						</td>
						<td>{{ tokenHeader.apiToken }}</td>
						<td>{{ tokenHeader.user?.login }} </td>
						<td>{{ tokenHeader.createdByUser?.login }} </td>
						<td>{{ tokenHeader.description }}</td>
						<td>{{ tokenHeader.createdTs | date:"M/d/yyyy h:mm a" }}</td>

					</tr>
				</ng-container>
			</tbody>
		</table>

	</div>
	<pagination-controls class="pagination" id="apitoken_pagination" (pageChange)="pageChanged($event)"
		[directionLinks]="true" nextLabel="Next" previousLabel="Prev" [autoHide]="true">
	</pagination-controls>
</div>
<app-confirm-delete-dialog #confirmDeleteDialog (confirmEvent)="deleteApiToken()"></app-confirm-delete-dialog>
<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>